import { OrgReferenceSettingsComponent } from "./org-reference-settings.component";
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AlertMessageModule} from "../../lib/alert-message/alert-message.module";
import {BsModalService, ModalModule} from "ngx-bootstrap/modal";
import {AlertBannerModule} from "../../lib/alert-banner";
import {OrgLogoModalModule} from "../org-logo-modal/org-logo-modal.module";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import { BrandColorsModalModule } from "../brand-colors-modal/brand-colors-modal.module";
import { BrandNameModalModule } from "../brand-name-modal/brand-name-modal.module";
import { ParticipantLangModalModule } from "../participant-lang-modal/participant-lang-modal.module";
import { QuestionnaireLimitModalModule } from "../questionnaire-limit-modal/questionnaire-limit-modal.module";
import { OrgDetailsModalModule } from "../org-details-modal/org-details-modal.module";
import { OrgNameModalModule } from "../org-name-modal/org-name-modal.module";
import { CandidateRefereeNotesModalModule } from "../candidate-referee-notes-modal/candidate-referee-notes-modal.module";
import { XrefApiKeyModalModule } from "../xref-api-key-modal/xref-api-key-modal.module";
import { OrgDepartmentsModalModule } from "../org-departments-modal/org-departments-modal.module";
import { OrgDeleteDepartmentModalModule } from "../org-delete-department-modal/org-delete-department-modal.module";
import {
  ShareTrackExpiryReportModalModule
} from "../share-track-expiry-report-modal/share-track-expiry-report-modal.module";

@NgModule({
    declarations: [OrgReferenceSettingsComponent],
    imports: [
      CommonModule,
      AlertMessageModule,
      ModalModule,
      BrandColorsModalModule,
      BrandNameModalModule,
      ParticipantLangModalModule,
      QuestionnaireLimitModalModule,
      TooltipModule.forRoot(),
      AlertBannerModule.forRoot(),
      OrgDetailsModalModule,
      OrgDepartmentsModalModule,
      OrgDeleteDepartmentModalModule,
      OrgLogoModalModule,
      OrgNameModalModule,
      CandidateRefereeNotesModalModule,
      XrefApiKeyModalModule,
      ShareTrackExpiryReportModalModule
    ],
    exports: [OrgReferenceSettingsComponent],
  })
  export class OrgReferenceModule { }
